export default __webpack_public_path__ + "static/media/logo_white.d8720fba.svg";